import { createFileRoute } from '@tanstack/react-router'
import Transliteration from 'pages/transliteration'
import { canonicalLink, pageMeta, translitAlternates, TRANSLIT_URL_TH } from 'lib/seo'

// The Thai-language name for the transliteration page ("karaoke language").
// This URL ranks in Thai-language search, so it renders the page itself —
// its earlier life as a redirect made its own canonical circular, which a
// search engine ignores.

const TranslitTitleTh = 'แปลไทยเป็นภาษาคาราโอเกะ รวดเร็ว ง่ายๆ'
const TranslitDescriptionTh =
   'แปลงข้อความภาษาไทยเป็นภาษาคาราโอเกะ (ตัวอักษรภาษาอังกฤษ) อัตโนมัติ ฟรี รวดเร็ว ง่ายๆ'

const TransliterationTh = () => <Transliteration lang="th" />

export const Route = createFileRoute('/ภาษาคาราโอเกะ')({
   head: () => ({
      meta: pageMeta({
         title: TranslitTitleTh,
         description: TranslitDescriptionTh,
         url: TRANSLIT_URL_TH,
      }),
      links: [canonicalLink(TRANSLIT_URL_TH), ...translitAlternates],
   }),
   component: TransliterationTh,
})
